import { IUserDetailsInfo } from "../../Profile/interface/IUserDetails";
import { ICustomService } from "@common/SelectYourNumber/interface/ISubscription";
import { IUserAddress } from "@common/Eircode/interface/IAddressForm";

interface IUserAddressPayload extends Omit<IUserAddress, "code"> {
    code?: string | null;
}

export interface IReplacementSimOrderPayload {
    address: IUserAddressPayload;
    barServices: boolean;
    email: string;
    firstName: string;
    lastName: string;
    phoneNumber: string;
    serviceId: number;
}

export const getStateToPayload = (
    formData: IUserAddress,
    barPreviousSim: boolean,
    userDetails: IUserDetailsInfo,
    selectedService: ICustomService
): IReplacementSimOrderPayload => ({
    address: {
        addressLine1: formData.addressLine1,
        addressLine2: formData.addressLine2,
        addressLine3: formData.addressLine3,
        code: formData.code ? formData.code.replace(/\s/g, "") : null,
        county: formData.county,
        town: formData.town,
    },
    barServices: barPreviousSim,
    email: userDetails.email,
    firstName: userDetails.firstName,
    lastName: userDetails.lastName,
    phoneNumber: userDetails.phoneNumber,
    serviceId: selectedService.id,
});
